import { render, staticRenderFns } from "./VploadVideo.vue?vue&type=template&id=4923b42f&scoped=true&"
import script from "./VploadVideo.vue?vue&type=script&lang=js&"
export * from "./VploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./VploadVideo.vue?vue&type=style&index=0&id=4923b42f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923b42f",
  null
  
)

export default component.exports